import React, { Fragment } from "react";
import { EditableArea } from "@magnolia/react-editor";
import { useIsHomePage } from "../../../utils/location";
import HtmlHeader from "../../../components/magnolia/htmlHeader/HtmlHeader";
import Footer from "../../../components/magnolia/footer/Footer";

// For Homepage, Footer area is rendered here to make it editable, otherwise it's render in BaseLayout component

const Standard = ({ main, footer, title, meta, geo }) => {
    const isHomePage = useIsHomePage();

    return (
        <Fragment>
            <HtmlHeader title={title} meta={meta} geo={geo} />
            {main && <EditableArea content={main} className="component-stack" />}
            {isHomePage && footer && <EditableArea content={footer} customView={Footer} />}
        </Fragment>
    );
};

export default Standard;
